<template>
  <div class="tooltip" @mouseover="onTriggerMouseEnter" @mouseleave="onTriggerMouseLeave" ref="trigger">
    <v-icon :class="{ 'disabled': disabled }" class="info-icon" :color="color ? color : '#ccc200'">{{ icon ? icon : 'mdi-information' }}</v-icon>
  </div>
</template>

<script>
import amplitude from 'amplitude-js'

export default {
  name: 'InfoTooltip',
  props: ['content', 'position', 'color', 'icon', 'props', 'disabled', 'compact'],
  data () {
    return {
      active: false,
      portalEl: null,
      hoverPortal: false,
      hideTimeout: null
    }
  },
  methods: {
    ensurePortal () {
      if (!this.portalEl) {
        const el = document.createElement('div')
        el.className = `tooltip-ctn ${this.compact ? 'compact' : 'pa-4'}`
        el.innerHTML = `<span>${this.content}</span>`
        document.body.appendChild(el)
        this.portalEl = el

        // Hover handling on tooltip content
        this.portalEl.addEventListener('mouseenter', () => {
          this.hoverPortal = true
          this.cancelHide()
        })
        this.portalEl.addEventListener('mouseleave', () => {
          this.hoverPortal = false
          this.scheduleHide()
        })

        // Click handling for links inside tooltip
        this.portalEl.addEventListener('click', (event) => {
          if (event.target && event.target.hash) {
            event.preventDefault()
            if (event.target.hash === '#/upgrade') {
              amplitude.getInstance().logEvent('Plan upgrade open')
            }
            parent.postMessage({ type: 'editor.navigation', hash: event.target.hash }, '*')
          }
        })
      }
    },
    onTriggerMouseEnter () {
      if (this.disabled) return
      this.showTooltip()
    },
    onTriggerMouseLeave () {
      this.scheduleHide()
    },
    scheduleHide () {
      this.cancelHide()
      this.hideTimeout = setTimeout(() => {
        if (!this.hoverPortal) {
          this.hideTooltip()
        }
      }, 120)
    },
    cancelHide () {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout)
        this.hideTimeout = null
      }
    },
    showTooltip () {
      this.active = true
      this.ensurePortal()
      this.$nextTick(() => {
        const trigger = this.$refs.trigger
        const tooltip = this.portalEl
        if (!trigger || !tooltip) return
        const rect = trigger.getBoundingClientRect()
        const spacing = 8
        tooltip.style.display = 'block'
        let top = rect.bottom + spacing
        let left = rect.left
        if (this.position === 'top') {
          top = rect.top - tooltip.offsetHeight - spacing
        } else if (this.position === 'right') {
          top = rect.top
          left = rect.right + spacing
        } else if (this.position === 'left') {
          top = rect.top - 5
          left = rect.left - tooltip.offsetWidth - spacing
        }
        const maxLeft = window.innerWidth - tooltip.offsetWidth - 8
        left = Math.max(8, Math.min(left, maxLeft))
        top = Math.max(8, Math.min(top, window.innerHeight - tooltip.offsetHeight - 8))
        tooltip.style.left = `${left}px`
        tooltip.style.top = `${top}px`
      })
    },
    hideTooltip () {
      this.active = false
      if (this.portalEl) {
        this.portalEl.style.display = 'none'
        this.portalEl.style.visibility = 'visible'
      }
    }
  },
  beforeDestroy () {
    this.cancelHide()
    if (this.portalEl && this.portalEl.parentNode) {
      this.portalEl.parentNode.removeChild(this.portalEl)
      this.portalEl = null
    }
  }
}
</script>

<style lang="sass" scoped>
@import '@/variables.sass'

.tooltip
  position: relative
  width: 24px
  height: 24px
  display: inline-flex
  align-items: center
  justify-content: center

  .info-icon
    font-size: 18px

  .disabled
    opacity: 0.5

:global(.tooltip-ctn)
  z-index: 10000
  height: auto
  background: #ffffff !important
  color: #1f2937
  padding: 10px 12px
  border-radius: 10px
  box-shadow: 0 8px 24px rgba(0,0,0,0.18)
  max-width: 320px
  min-width: 220px
  line-height: 1.5
  border: 1px solid rgba(0,0,0,0.08)
  display: inline-block
  box-sizing: border-box
  white-space: normal
  word-wrap: break-word
  word-break: normal

  font-family: 'Roboto'
  font-size: 13px

  position: fixed
  pointer-events: auto

  &.compact
    padding: 8px 10px
    font-size: 11px
    max-width: 370px

</style>
